/*global jQuery:false */
var QUEO = window.QUEO ||{};

QUEO.Config = $.extend(true, {
	// Globaler Debug-Parameter, welcher in QUEO.Utils.js genutzt wird
	debug: true,

    breakpointLaptop:1221,
    breakpointTablet:919,
    breakpointMobile:519,

    transitionDurationShort: 300,
    transitionDurationMedium: 500,
    transitionDurationLong: 800,
    transitionDurationModal: 500

}, QUEO.Config);